/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer'
import { extrudeSettings } from '../../../../../../utils/Functions'
import HandleOneModel from '../../../ShareModel/HandleModel/HandleOneModel'
import PatternOneModel from '../../../ShareModel/PatternModel/PatternOneModel'

const SolidWalkInDoor = ({ width, height, trimWidth, doorColor, glassTexture, handlePlacement, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    
    const doorWidth = width - trimWidth * 2
    const doorHeight = height - trimWidth    
    const unitCountX = 20;
    const unitCountY = 30;
    const unitWidth = doorWidth / unitCountX;
    const unitHeight = doorHeight / unitCountY;
    const marginX = unitWidth * 2.5;
    const holeDistanceX = unitWidth * 3
    const holeWidth = (doorWidth - marginX * 2 - holeDistanceX) / 2;    
    const marginY = unitHeight * 2
    const holeDistanceY = unitHeight * 2.5
    const smallHoleHeight = (doorHeight - marginY * 2 - holeDistanceY * 2) / 7
    const largeHoleHeight = smallHoleHeight * 3

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [height, trimWidth, width])

    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - 0.03) + trimWidth,  (height / 2 - 0.03) - trimWidth);
        model.lineTo(-(width / 2 - 0.03) + trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  (height / 2 - 0.03) - trimWidth);
        model.closePath();

        for (let i = 0; i < 2; i ++) {
            const hole_upper = new THREE.Path();
            hole_upper.moveTo(Math.pow(-1, i) * (holeDistanceX / 2),                height / 2 - trimWidth - marginY - smallHoleHeight);
            hole_upper.lineTo(Math.pow(-1, i) * (holeDistanceX / 2),                height / 2 - trimWidth - marginY);
            hole_upper.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    height / 2 - trimWidth - marginY);
            hole_upper.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    height / 2 - trimWidth - marginY - smallHoleHeight);
            hole_upper.closePath();

            const hole_mid = new THREE.Path();
            hole_mid.moveTo(Math.pow(-1, i) * (holeDistanceX / 2),                -height / 2 + marginY + holeDistanceY + largeHoleHeight * 1);
            hole_mid.lineTo(Math.pow(-1, i) * (holeDistanceX / 2),                -height / 2 + marginY + holeDistanceY + largeHoleHeight * 2);
            hole_mid.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    -height / 2 + marginY + holeDistanceY + largeHoleHeight * 2);
            hole_mid.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    -height / 2 + marginY + holeDistanceY + largeHoleHeight * 1);
            hole_mid.closePath();

            const hole_under = new THREE.Path();
            hole_under.moveTo(Math.pow(-1, i) * (holeDistanceX / 2),                -height / 2 + marginY);
            hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2),                -height / 2 + marginY + largeHoleHeight);
            hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    -height / 2 + marginY + largeHoleHeight);
            hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    -height / 2 + marginY);
            hole_under.closePath();

            model.holes.push(hole_upper);
            model.holes.push(hole_mid);
            model.holes.push(hole_under);
        }

        return model;
    
    }, [height, trimWidth, width])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='pattern-door' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
            
            <HandleOneModel handlePlacement={handlePlacement} width={width}  handleModel={handleModel} />
            
            {new Array(2).fill("").map((_, index) => 
                <group key={`pattern-model-${index}`} position={[Math.pow(-1, index) * (holeDistanceX / 2 + holeWidth / 2), 0, 0]}>
                    <group name='pattern-upper' position={[0, height / 2 - trimWidth - marginY - smallHoleHeight / 2, 0]}>
                        <PatternOneModel modelWidth={holeWidth} modelHeight={smallHoleHeight} doorColor={doorColor}  />
                    </group>
                    <group name='middle' position={[0, -height / 2 + marginY + largeHoleHeight + holeDistanceY + largeHoleHeight / 2, 0]}>
                        <PatternOneModel modelWidth={holeWidth} modelHeight={largeHoleHeight} doorColor={doorColor}  />
                    </group>
                    <group name='under' position={[0, -height / 2 + marginY + largeHoleHeight / 2, 0]}>
                        <PatternOneModel modelWidth={holeWidth} modelHeight={largeHoleHeight} doorColor={doorColor}  />
                    </group>
                </group>
            )}
        </>
    )
}

export default SolidWalkInDoor